import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Clock, User, CalendarOff, Bell } from 'lucide-react';
import { cn } from '@/lib/utils';
import { notificationAPI } from '@/lib/api';
import { useTranslation } from 'react-i18next';

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  const { t } = useTranslation();

  const navItems = [
    { path: '/employee', icon: Home, label: t('common.home'), key: 'home' },
    { path: '/employee/history', icon: Clock, label: t('common.history'), key: 'history' },
    { path: '/employee/leaves', icon: CalendarOff, label: t('common.leaves'), key: 'leaves' },
    { path: '/employee/notifications', icon: Bell, label: t('common.alerts'), key: 'alerts' },
    { path: '/employee/profile', icon: User, label: t('common.profile'), key: 'profile' },
  ];

  useEffect(() => {
    notificationAPI.getAll(1).then(res => {
      setUnread(res.data?.unread_count || 0);
    }).catch(() => {});
    const interval = setInterval(() => {
      notificationAPI.getAll(1).then(res => {
        setUnread(res.data?.unread_count || 0);
      }).catch(() => {});
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-[999] bg-white border-t border-border/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="grid grid-cols-5 h-16 max-w-md mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const showBadge = item.key === 'alerts' && unread > 0;
          return (
            <button
              key={item.path}
              data-testid={`nav-${item.key}`}
              onClick={() => navigate(item.path)}
              className={cn(
                'relative flex flex-col items-center justify-center gap-0.5 transition-all active:scale-95',
                isActive
                  ? 'text-[#026536]'
                  : 'text-[#1a2529]/40 hover:text-[#1a2529]/70'
              )}
            >
              <div className="relative">
                <item.icon size={20} strokeWidth={isActive ? 2.2 : 1.5} />
                {showBadge && (
                  <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                    {unread > 9 ? '9+' : unread}
                  </span>
                )}
              </div>
              <span className={cn('text-[10px] font-semibold', isActive && 'text-[#026536]')}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute bottom-2 w-5 h-0.5 rounded-full bg-[#026536]" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
